<template>
    <div class="search-block w-[90%] mx-auto">
        <div class="flex justify-between mt-2">
            <div class="search-bar flex items-center border-[#FFF] border-[1px] bg-[#FFF] bg-opacity-30 px-[10px] rounded-[6px]">
                <img src="@/assets/icons/magnify_icon.svg" class="w-3 h-3">
                <input
                    v-model="searchQuery"
                    class="text-[#FFF] text-[14px] bg-transparent rounded-md px-2 py-[3.5px] placeholder:text-[#FFF] outline-none w-[250px]"
                    placeholder="Пошук..."
                    type="text"
                    @input="$emit('search', $event.target?.value || '')"
                >
            </div>
            <div class="filter">
                <button @click="$emit('upload')" class="bg-[#BD9135] hover:bg-[#a77f2b] w-[228px] text-white px-4 py-[6px] text-[14px] rounded-md">
                    Завантажити файл
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'

    export default {
        name: 'file-storage-menu-bar',

        emits: ['upload', 'search'],

        setup() {
            const searchQuery = ref('')
            return { searchQuery }
        }
    }
</script>
